// Translation file for KotelezoSzakmaiGyakorlat component
// Contains all UI text in Hungarian and English

export const KOTELEZOSZAKMAIGYAKORLAT_TRANSLATIONS = {
    hu: {
        pageTitle: "5. Kötelező szakmai gyakorlat",
        source: "Forrás: ",
        
        section1: {
            subtitle1: "A szakmai gyakorlattal kapcsolatos információk elérhetősége és minősége",
            subtitle2: "A vizsgált időszakban a szakmai gyakorlatot biztosító partnerek száma",
            subtitle3: "Partnerek típusa (több válasz is jelölhető)",
        },
        
        section2: {
            title: "A vizsgált évben volt-e kapcsolatfelvétel alumnival, cégekkel, szakmai szervezetekkel",
            subtitle1: "Alumni kapcsolatok",
            subtitle2: "Vállalati kapcsolatfelvétel",
            subtitle3: "Szakmai szervezetekkel való kapcsolat",
        },
        
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        modal: {
            imageAlt: "Nagyított kép",
            closeButton: "Bezárás"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        pageTitle: "5. Compulsory Internship",
        source: "Source: ",
        
        section1: {
            subtitle1: "Availability and quality of information related to the internship",
            subtitle2: "Number of partner organizations providing professional internships during the review period",
            subtitle3: "Types of partner organizations (multiple answers may be selected)",
        },
        
        section2: {
            title: "Was there engagement with alumni, companies, or professional organizations during the review year",
            subtitle1: "Alumni relations",
            subtitle2: "Corporate engagement",
            subtitle3: "Engagement with professional organizations",
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw Finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        modal: {
            imageAlt: "Enlarged image",
            closeButton: "Close"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};